import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";
Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        requiresAuth: true,
      },
      component: () => import("./components/Common/Default"),
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          props: true,
          component: () => import("./components/Dashboard/dashboard"),
          meta: {
            requiresAuth: false,
          },
        },
        
        {
          name: 'user',
          path: 'users/user',
          component: () =>
              import ('./components/views/users/user'),
        },
        
        {
          name: 'userDetails',
          path: 'users/userDetails/:userid',
          props: true,
          component: () =>
              import ('./components/views/users/userDetails'),
      },
      {
          name: 'edit',
          path: 'users/edit/:userid',
          props: true,
          component: () =>
              import ('./components/views/users/edit'),
      },

        
        {
          name: 'seller',
          path: 'sellers/seller',
          component: () =>
              import ('./components/views/sellers/seller'),
      },
      {
          name: 'sellerDetails',
          path: 'sellers/sellerDetails/:sellerid',
          props: true,
          component: () =>
              import ('./components/views/sellers/sellerDetails'),
      },
      {
          name: 'editSeller',
          path: 'sellers/editSeller/:sellerid',
          props: true,
          component: () =>
              import ('./components/views/sellers/editSeller'),
      },
      {
          name: 'pendingSellers',
          path: '/pendingSellers',
          component: () =>
              import ('./components/views/sellers/pendingSellers'),
      },
      {
          name: 'pendingSellerDetails',
          path: '/pendingSellerDetails/:sellerid',
          props: true,
          component: () =>
              import ('./components/views/sellers/pendingSellerDetails'),
      },
      {
          name: 'removeSellers',
          path: '/removeSellers',
          component: () =>
              import ('./components/views/sellers/removeSellers'),
      },
      {
          name: 'removeSellerDetails',
          path: '/removeSellerDetails/:sellerid',
          props: true,
          component: () =>
              import ('./components/views/sellers/removeSellerDetails'),
      },

        {
          path: "SellerList",
          name: "SellerList",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./components/Seller/sellerList"),
        },
        {
          path: "SellerInfo",
          name: "SellerInfo",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./components/Seller/sellerInfo"),
        },

        {
          path: "editSeller",
          name: "editSeller",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./components/Seller/edit/editSellerProfile"),
        },
      ],
    },

    {
      path: "/",
      props: true,
      component: () => import("./components/Authentication/Authentication"),
      meta: {
        requiresAuth: false,
      },
      children: [
        {
          path: "login",
          name: "login",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./components/Authentication/adminLogin"),
        },
        // {
        //   path: "signup",
        //   name: "signup",
        //   meta: {
        //     requiresAuth: false,
        //   },
        //   component: () => import("./components/Authentication/Signup"),
        // },
      ],
    },

    {
      path: "*",
      name: "404pagenotfound",
      props: true,
      component: () => import("./components/Common/404"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/servererror",
      name: "servererror",
      props: true,
      component: () => import("./components/Common/500"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
  scrollBehavior() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((route) => route.meta.requiresAuth == true) &&
    store.state.isLoggedIn == false
  ) {
    console.log(from);
    next({ name: "login", params: { lastPage: from } });
    return;
  }

  if (
    (to.name == "login" || to.name == "home") &&
    store.state.isLoggedIn == true
  ) {
    next({ name: "dashboard" });
    return;
  }

  if (store.state.isLoggedIn == true) {
    axios({
      method: "POST",
      url: "/validate/token",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.data.status) {
          store.commit("sessionOut", true);
          return;
        }
      })
      .catch((err) => {
        var msg = err;
        console.log(msg);
      });
  }

  next();
});

export default router;
